var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.029 0H6.80005V3.33333H18.7V13.3333H25.5V10H22.1V5.28333L30.6 12.4333V18.3333H34V10.9L21.029 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 31.6667V0H0V31.6667V40H6.8V36.6667H3.4V31.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 36.6666H25.5V40H34V33.3333H30.6V36.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8059 16.8L12.2059 30.1334L10.4039 38.9667L19.4139 37.2001L33.0139 23.8667L25.8059 16.8ZM28.2199 23.8667L25.8059 26.2167L23.4089 23.8667L25.8059 21.5L28.2199 23.8667ZM17.7649 34.1167L14.7559 34.7L15.2999 31.75L20.9439 26.2167L23.3579 28.5834L17.7649 34.1167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrades);
export default __webpack_public_path__ + "static/media/trades.e23a21204cdcbcfcc253bd61730e9c6d.svg";
export { ForwardRef as ReactComponent };